// app/javascript/controllers/discount_sales_controller.js
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="discount-sale"
export default class extends Controller {
  static targets = ["previousPrice", "previousCost", "price", "cost"];

  connect() {}

  updatePrice(event) {
    const previousTotalPrice = parseInt(
      this.previousPriceTarget.getAttribute("value") || 0
    );
    const totalPrice = parseInt(event.target.value || 0);
    const resultPrice = previousTotalPrice + totalPrice;
    this.priceTarget.textContent = resultPrice.toLocaleString();
  }

  updateCost(event) {
    const previousTotalCost = parseInt(
      this.previousCostTarget.getAttribute("value") || 0
    );
    const totalCost = parseInt(event.target.value || 0);
    const resultCost = previousTotalCost + totalCost;
    this.costTarget.textContent = resultCost.toLocaleString();
  }
}
